var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { createForecastTableRow, refreshIframe, setDate, setMetar, setTime, setWeather } from './common';
import { getForecast } from './forecast';
/**
 * Enables the "atmospheric sciences" page functionality.
 */
const enableAtmosphericSciencesFunctionality = () => __awaiter(void 0, void 0, void 0, function* () {
    if ($('#atmospheric-sciences').length === 0) {
        return;
    }
    yield setWeather('current-weather-summary', 'current-weather-details');
    yield _getForecast();
    setDate('date-data');
    yield setMetar('metar-data');
    setTime('time-data');
    // refresh the digital signage every hour
    setInterval(() => {
        refreshIframe('digital-signage');
    }, (1000 * 60 * 60));
    // refresh the radar every 5 minutes
    setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        refreshIframe('radar');
    }), (1000 * 60 * 5));
    // refresh the weather and METAR data every minute
    setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        yield setWeather('current-weather-summary', 'current-weather-details');
        yield _getForecast();
        yield setMetar('metar-data');
    }), (1000 * 60));
    // refresh the current date/time every second
    setInterval(() => {
        setDate('date-data');
        setTime('time-data');
    }, (1000 * 1));
    /**
     * Sets the current weather forecast data on the page.
     */
    function _getForecast() {
        return __awaiter(this, void 0, void 0, function* () {
            const forecastContent = $('#forecast-content');
            const forecastNoData = $('#forecast-no-data');
            const periods = yield getForecast(47.9169, -97.0720);
            if (periods && periods[0]) {
                forecastContent.empty();
                forecastContent.append(createForecastTableRow(periods[0]));
                forecastContent.show();
                forecastNoData.hide();
            }
            else {
                forecastContent.hide();
                forecastNoData.show();
            }
        });
    }
});
export default enableAtmosphericSciencesFunctionality;
